// 9fbef606107a605d69c0edbcd8029e5d
import { getAPIConfig } from '@tcp/core/src/utils';
import logger from '@tcp/core/src/utils/loggerInstance';
import endpoints from '@tcp/core/src/services/endpoints';
import { executeStatefulAPICall } from '@tcp/core/src/services/handler/handler';

const Abstractor = {
  /**
   * Fetches loyalty tier benefits data.
   * @param {string} file - The file name for loyalty tier benefit data.
   * @returns {Promise<Object>} Promise that resolves to loyalty tier benefit data.
   */
  getLoyaltyTierBenefitData: async (file) => {
    try {
      const { brandId, loyaltyTierBenefitPrefix, locale } = getAPIConfig();
      const loyaltyTierBenefitConfig = endpoints.getJsonURL(
        loyaltyTierBenefitPrefix,
        brandId,
        file,
        locale
      );
      const timestamp = new Date().getTime(); // Generate timestamp
      const updatedUrl = {
        ...loyaltyTierBenefitConfig,
        URI: `${loyaltyTierBenefitConfig.URI}?t=${timestamp}`, // Append timestamp
      };
      const reqObj = {
        webService: updatedUrl,
        skipApiIdentifier: true,
      };
      const res = await executeStatefulAPICall(reqObj);

      if (!res?.ok || !res.body) {
        logger.error(
          `Failed to fetch loyalty tier benefit data from ${updatedUrl.URI} for ${file} file`
        );
        throw new Error(`Failed to fetch loyalty tier benefit data`);
      }

      return {
        ...res.body,
        timestamp,
      };
    } catch (error) {
      logger.error(`Error fetching loyalty tier benefit Data of ${file} -`, error);
      throw error;
    }
  },
};

export default Abstractor;
